export enum LocalStorageKeys {
  COLORS_THEME = 'colorsTheme',
  FILTERS = 'filters',
  FONT_FAMILIES_THEME = 'fontFamiliesTheme',
  FONTS_THEME = 'fontsTheme',
  IMPERSONATION = 'impersonation',
  LOGGED_USER = 'loggedUser',
  LOGO_PATHS = 'logoPaths',
}
